import React from "react";
import { BaseCriteria, CriteriaGroup } from "../../../models/criteria";

interface CriteriaGroupDisplayProps {
  readonly criteriaGroup: CriteriaGroup;
}

const getCodingParamString = (type: string, display?: string): string => {
  const codingDisplay = `<strong>${display}</strong>`;

  switch (type) {
    case "DRUG":
      return `At least one exposure of ${codingDisplay}`;
    case "OBSERVATION":
      return `At least one observation of ${codingDisplay}`;
    case "CONDITION":
    case "PROCEDURE":
      return `At least one occurrence of ${codingDisplay}`;
    case "MEASUREMENT":
      return `At least one mention of ${codingDisplay}`;
    case "DEVICE":
      return `At least one exposure of device ${codingDisplay}`;
    default:
      return "";
  }
};

const getParamString = (params: any, type: string): string => {
  if (typeof params !== "object") {
    return `${params}`;
  }

  if ("gender" in params) {
    return `Only ${params.gender}`;
  }

  if ("deceased" in params) {
    return params.deceased ? "Deceased" : "Still alive";
  }

  if ("coding" in params) {
    return getCodingParamString(type, params.coding?.display);
  }

  if ("minAge" in params && "maxAge" in params) {
    return `AGE >= ${params.minAge} and <= ${params.maxAge}`;
  }

  if ("base_coding" in params && "value_coding" in params) {
    return `With <strong>${params.base_coding?.display}</strong> equals to <strong>${params.value_coding?.display}</strong>`;
  }

  return "";
};

export default function CriteriaGroupDisplay({ criteriaGroup }: CriteriaGroupDisplayProps) {
  const generateCriteriaString = React.useMemo(
    () => (criteriaGroup: CriteriaGroup) => {
      return criteriaGroup.criteria_list
        .map((c: BaseCriteria) => {
          const { type, params } = c;
          return getParamString(params, type);
        })
        .join(` <br /><small>${criteriaGroup.operator}</small> `);
    },
    []
  );

  return <div dangerouslySetInnerHTML={{ __html: generateCriteriaString(criteriaGroup) }} />;
}
